import { render, staticRenderFns } from "./base-quantity-small-card.vue?vue&type=template&id=530a2329&scoped=true&"
import script from "./base-quantity-small-card.vue?vue&type=script&lang=js&"
export * from "./base-quantity-small-card.vue?vue&type=script&lang=js&"
import style0 from "./base-quantity-small-card.vue?vue&type=style&index=0&id=530a2329&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a2329",
  null
  
)

export default component.exports